// Module
var code = `<div ng-switch on="\$ctrl.link">
  <div ng-switch-when="NA|NULL" ng-switch-when-separator="|"></div>
  <div ng-switch-when="modal" class="{{\$ctrl.align}}">
    <button type="button" ng-click="\$ctrl.openModal()" ng-class="[\$ctrl.btnclass, 'mt-0']">{{\$ctrl.text}}<i ng-class="[\$ctrl.btnarrow, 'ms-2']"></i></button>
  </div>
  <div ng-switch-when="disabled" class="{{\$ctrl.align}}">
    <button type="button" disabled ng-class="[\$ctrl.btnclass, 'mt-0']">{{\$ctrl.text}}<i ng-class="[\$ctrl.btnarrow, 'ms-2']"></i></button>
  </div>
  <div ng-switch-when="optin" class="{{\$ctrl.align}}">
    <button type="button" ng-click="\$ctrl.optin(\$event)" ng-class="[\$ctrl.btnclass, 'mt-0']">{{\$ctrl.text}}<i ng-class="[\$ctrl.btnarrow, 'ms-2']"></i></button>
  </div>
  <div ng-switch-when="onclick" class="{{\$ctrl.align}}">
    <button type="button" ng-click="\$ctrl.onClick()" ng-class="[\$ctrl.btnclass, 'mt-0']">{{\$ctrl.text}}<i ng-class="[\$ctrl.btnarrow, 'ms-2']"></i></button>
  </div>
  <div ng-switch-when="scroll" class="{{\$ctrl.align}}">
    <button type="button" ng-click="\$ctrl.scrollTo(\$ctrl.target)" ng-class="[\$ctrl.btnclass, 'mt-0']">{{\$ctrl.text}}<i ng-class="[\$ctrl.btnarrow, 'ms-2']"></i></button>
  </div>
  <a ng-switch-default
     ng-if="\$ctrl.link" ng-href="{{\$ctrl.AppService.cta(\$ctrl.link)}}"
     ng-class="[\$ctrl.btnclass, 'mt-0']"
     ng-attr-target="{{\$ctrl.target}}">
    {{\$ctrl.text}}
    <i ng-class="[\$ctrl.btnarrow, 'ms-2']"></i>
  </a>
</div>`;
// Exports
module.exports = code;